import { NgModule } from '@angular/core';
import { Routes, RouterModule, CanActivate } from '@angular/router';

import { HomeComponent } from './pages/student-page/home/home.component';
import { AuthGuardService as AuthGuard } from './auth/auth-guard.service';
import { RoleStudentGuardService as RoleStudentGuard } from './auth/role-student-guard.service';
import { RoleAdministratorGuardService as RoleAdministratorGuard } from './auth/role-administrator-guard.service';
import { RoleInstructorGuardService as RoleInstructorGuard } from './auth/role-instructor-guard.service';
import { RoleTutorGuardService as RoleTutorGuard } from './auth/role-tutor-guard.service';
import { GroupComponent } from './pages/student-page/group/group.component';
import { GroupsComponent } from './pages/student-page/groups/groups.component';
import { SelfStudyComponent } from './pages/student-page/self-study/self-study.component';
import { InstructorComponent } from './pages/student-page/instructor/instructor.component';
import { TutorComponent } from './pages/student-page/tutor/tutor.component';
// tslint:disable-next-line: max-line-length
import { PrenotazioneLaboratorioComponent } from './pages/student-page/laboratorio/prenotazione-laboratorio/prenotazione-laboratorio.component';
import { InstructorsComponent } from './pages/student-page/instructors/instructors.component';
import { TutorsComponent } from './pages/student-page/tutors/tutors.component';
import { DashboardAdministratorComponent } from './pages/administrator-page/dashboard-administrator/dashboard-administrator.component';
import { DashboardInstructorComponent } from './pages/administrator-page/dashboard-instructor/dashboard-instructor.component';
import { DashboardTutorComponent } from './pages/administrator-page/dashboard-tutor/dashboard-tutor.component';
import { ListPrenotazioniComponent } from './pages/student-page/laboratorio/list-prenotazioni/list-prenotazioni.component';
import { ModificaProfiloComponent } from './pages/student-page/modifica-profilo/modifica-profilo.component';
import { PrenotazioniEsamiComponent } from './pages/student-page/prenotazioni-esami/prenotazioni-esami.component';
// tslint:disable-next-line: max-line-length
import { RoleInstructorOrAdministratorGuardService as RoleInstructorOrAdministratorGuard } from './auth/role-instructor-or-administrator-guard.service';
import { RoleTutorOrAdministratorGuardService as RoleTutorOrAdministratorGuard } from './auth/role-tutor-or-administrator-guard.service';
// tslint:disable-next-line: max-line-length
import { RoleAdministratorOrTutorOrInstractorGuardService as RoleAdministratorOrTutorOrInstractorGuard } from './auth/role-tutor-or-instructor-or-administrator-guard.service';
import { LogOperazioneComponent } from './pages/administrator-page/log-operazione/log-operazione.component';
// tslint:disable-next-line: max-line-length
import { DashboardManagerDidatticoComponent } from './pages/administrator-page/dashboard-manager-didattico/dashboard-manager-didattico.component';
import { DashboardAdvisorComponent } from './pages/administrator-page/dashboard-advisor/dashboard-advisor.component';
import { RoleStudentOrTutorGuardService } from './auth/role-student-or-tutor-guard.service';
import { ElencoProveComponent } from './pages/student-page/elenco-prove/elenco-prove.component';
import { StatisticheComponent } from './pages/administrator-page/statistiche/statistiche.component';

const routes: Routes = [
  {
    path: '',
    data: {
      title: '',
    },
    children: [
      {
        path: '',
        component: HomeComponent,
        canActivate: [AuthGuard, RoleStudentGuard],
      },
      {
        path: 'dashboard-administrator',
        component: DashboardAdministratorComponent,
        canActivate: [AuthGuard, RoleAdministratorGuard],
      },
      {
        path: 'dashboard-manager-didattico',
        component: DashboardManagerDidatticoComponent,
        canActivate: [AuthGuard, RoleAdministratorGuard],
      },
      {
        path: 'dashboard-advisor',
        component: DashboardAdvisorComponent,
        canActivate: [AuthGuard, RoleAdministratorGuard],
      },
      {
        path: 'log-operazione',
        component: LogOperazioneComponent,
        canActivate: [AuthGuard, RoleAdministratorGuard],
      },
      {
        path: 'a-statistiche',
        component: StatisticheComponent,
        canActivate: [AuthGuard, RoleAdministratorGuard],
      },
      {
        path: 'dashboard-instructor',
        component: DashboardInstructorComponent,
        canActivate: [AuthGuard, RoleInstructorGuard],
      },
      {
        path: 'dashboard-tutor',
        component: DashboardTutorComponent,
        canActivate: [AuthGuard, RoleTutorGuard],
      },
      {
        path: 'group',
        component: GroupComponent,
        canActivate: [AuthGuard, RoleStudentGuard],
      },
      {
        path: 'groups',
        component: GroupsComponent,
        canActivate: [AuthGuard, RoleStudentGuard],
      },
      {
        path: 'prenotazione-laboratorio',
        component: PrenotazioneLaboratorioComponent,
        canActivate: [AuthGuard, RoleStudentGuard],
      },
      {
        path: 'list-prenotazioni',
        component: ListPrenotazioniComponent,
        canActivate: [AuthGuard, RoleStudentGuard],
      },
      {
        path: 'prenotazioni-esami',
        component: PrenotazioniEsamiComponent,
        canActivate: [AuthGuard, RoleStudentGuard],
      },
      {
        path: 'elenco-prove',
        component: ElencoProveComponent,
        canActivate: [AuthGuard, RoleStudentGuard],
      },
      {
        path: 'self-study',
        component: SelfStudyComponent,
        canActivate: [AuthGuard, RoleStudentOrTutorGuardService],
      },
      {
        path: 'instructor',
        component: InstructorComponent,
        canActivate: [AuthGuard, RoleStudentGuard],
      },
      {
        path: 'tutor',
        component: TutorComponent,
        canActivate: [AuthGuard, RoleStudentGuard],
      },
      {
        path: 'instructors',
        component: InstructorsComponent,
        canActivate: [AuthGuard, RoleStudentGuard],
      },
      {
        path: 'tutors',
        component: TutorsComponent,
        canActivate: [AuthGuard, RoleStudentGuard],
      },
      {
        path: 'modifica-profilo',
        component: ModificaProfiloComponent,
        canActivate: [AuthGuard, RoleStudentGuard],
      },
      // AMMINISTRAZIONE
      {
        path: 'a-utente',
        data: {
          title: 'Utente',
        },
        children: [
          {
            path: 'list',
            loadChildren:
              './pages/administrator-page/utente/list/list-utenti.module#ListUtentiModule',
            canActivate: [AuthGuard, RoleAdministratorGuard],
          },
          {
            path: 'crea',
            loadChildren:
              './pages/administrator-page/utente/crea/crea-utente.module#CreaUtenteModule',
            canActivate: [AuthGuard, RoleAdministratorGuard],
          },
          {
            path: 'modifica',
            loadChildren:
              './pages/administrator-page/utente/modifica/modifica-utente.module#ModificaUtenteModule',
            canActivate: [AuthGuard, RoleAdministratorGuard],
          },
        ],
      },
      {
        path: 'a-aula',
        data: {
          title: 'Aula',
        },
        children: [
          {
            path: 'list',
            loadChildren:
              './pages/administrator-page/aula/list/list-aule.module#ListAuleModule',
            canActivate: [AuthGuard, RoleAdministratorGuard],
          },
          {
            path: 'crea',
            loadChildren:
              './pages/administrator-page/aula/crea/crea-aula.module#CreaAulaModule',
            canActivate: [AuthGuard, RoleAdministratorGuard],
          },
          {
            path: 'modifica',
            loadChildren:
              './pages/administrator-page/aula/modifica/modifica-aula.module#ModificaAulaModule',
            canActivate: [AuthGuard, RoleAdministratorGuard],
          },
        ],
      },
      {
        path: 'a-prova-finale',
        data: {
          title: 'Prova Finale',
        },
        children: [
          {
            path: 'list',
            loadChildren:
              './pages/administrator-page/prova-finale/list/list-prove-finali.module#ListProveFinaliModule',
            canActivate: [AuthGuard, RoleAdministratorGuard],
          },
          {
            path: 'crea',
            loadChildren:
              './pages/administrator-page/prova-finale/crea/crea-prova-finale.module#CreaProvaFinaleModule',
            canActivate: [AuthGuard, RoleAdministratorGuard],
          },
          {
            path: 'modifica',
            loadChildren:
              './pages/administrator-page/prova-finale/modifica/modifica-prova-finale.module#ModificaProvaFinaleModule',
            canActivate: [AuthGuard, RoleAdministratorGuard],
          },
        ],
      },
      {
        path: 'a-gruppo-studio',
        data: {
          title: 'Gruppo Studio',
        },
        children: [
          {
            path: 'dettaglio',
            loadChildren:
              './pages/administrator-page/gruppo-studio/dettaglio/dettaglio-gruppo-studio.module#DettaglioGruppoStudioModule',
            canActivate: [AuthGuard, RoleInstructorOrAdministratorGuard],
          },
          {
            path: 'calendario',
            // tslint:disable-next-line: max-line-length
            loadChildren:
              './pages/administrator-page/gruppo-studio/calendario/calendario-gruppo-studio.module#CalendarioGruppoStudioModule',
            canActivate: [AuthGuard, RoleInstructorOrAdministratorGuard],
          },
          {
            path: 'list',
            loadChildren:
              './pages/administrator-page/gruppo-studio/list/list-gruppi-studio.module#ListGruppiStudioModule',
            canActivate: [AuthGuard, RoleInstructorOrAdministratorGuard],
          },
          {
            path: 'crea',
            loadChildren:
              './pages/administrator-page/gruppo-studio/crea/crea-gruppo-studio.module#CreaGruppoStudioModule',
            canActivate: [AuthGuard, RoleAdministratorGuard],
          },
          {
            path: 'modifica',
            loadChildren:
              './pages/administrator-page/gruppo-studio/modifica/modifica-gruppo-studio.module#ModificaGruppoStudioModule',
            canActivate: [AuthGuard, RoleAdministratorGuard],
          },
        ],
      },
      {
        path: 'a-language-level',
        data: {
          title: 'Language Level',
        },
        children: [
          {
            path: 'list',
            loadChildren:
              './pages/administrator-page/language-level/list/list-language-level.module#ListLanguageLevelModule',
            canActivate: [AuthGuard, RoleInstructorOrAdministratorGuard],
          },
          {
            path: 'crea',
            loadChildren:
              './pages/administrator-page/language-level/crea/crea-language-level.module#CreaLanguageLevelModule',
            canActivate: [AuthGuard, RoleAdministratorGuard],
          },
          {
            path: 'modifica',
            loadChildren:
              './pages/administrator-page/language-level/modifica/modifica-language-level.module#ModificaLanguageLevelModule',
            canActivate: [AuthGuard, RoleAdministratorGuard],
          },
        ],
      },
      {
        path: 'a-corso-laurea',
        data: {
          title: 'Corso Laurea',
        },
        children: [
          {
            path: 'list',
            loadChildren:
              './pages/administrator-page/corso-laurea/list/list-corsi-laurea.module#ListCorsiLaureaModule',
            canActivate: [AuthGuard, RoleAdministratorGuard],
          },
          {
            path: 'crea',
            loadChildren:
              './pages/administrator-page/corso-laurea/crea/crea-corso-laurea.module#CreaCorsoLaureaModule',
            canActivate: [AuthGuard, RoleAdministratorGuard],
          },
          {
            path: 'modifica',
            loadChildren:
              './pages/administrator-page/corso-laurea/modifica/modifica-corso-laurea.module#ModificaCorsoLaureaModule',
            canActivate: [AuthGuard, RoleAdministratorGuard],
          },
        ],
      },
      {
        path: 'a-sessione-ola',
        data: {
          title: 'Sessione Ola',
        },
        children: [
          {
            path: 'list',
            loadChildren:
              './pages/administrator-page/sessione-ola/list/list-sessioni-ola.module#ListSessioniOlaModule',
            canActivate: [AuthGuard, RoleAdministratorGuard],
          },
          {
            path: 'crea',
            loadChildren:
              './pages/administrator-page/sessione-ola/crea/crea-sessione-ola.module#CreaSessioneOlaModule',
            canActivate: [AuthGuard, RoleAdministratorGuard],
          },
          {
            path: 'modifica',
            loadChildren:
              './pages/administrator-page/sessione-ola/modifica/modifica-sessione-ola.module#ModificaSessioneOlaModule',
            canActivate: [AuthGuard, RoleAdministratorGuard],
          },
        ],
      },
      {
        path: 'a-self-study',
        data: {
          title: 'Self Study',
        },
        children: [
          {
            path: 'list-categorie',
            loadChildren:
              './pages/administrator-page/self-study/list-categorie/list-categorie.module#ListCategorieModule',
            canActivate: [AuthGuard, RoleTutorOrAdministratorGuard],
          },
          {
            path: 'crea-categoria',
            loadChildren:
              './pages/administrator-page/self-study/crea-categoria/crea-categoria.module#CreaCategoriaModule',
            canActivate: [AuthGuard, RoleTutorOrAdministratorGuard],
          },
          {
            path: 'modifica-categoria',
            loadChildren:
              './pages/administrator-page/self-study/modifica-categoria/modifica-categoria.module#ModificaCategoriaModule',
            canActivate: [AuthGuard, RoleTutorOrAdministratorGuard],
          },
          {
            path: 'list-documenti',
            loadChildren:
              './pages/administrator-page/self-study/list-documenti/list-documenti.module#ListDocumentiModule',
            canActivate: [AuthGuard, RoleTutorOrAdministratorGuard],
          },
          {
            path: 'crea-documento',
            loadChildren:
              './pages/administrator-page/self-study/crea-documento/crea-documento.module#CreaDocumentoModule',
            canActivate: [AuthGuard, RoleTutorOrAdministratorGuard],
          },
          {
            path: 'modifica-documento',
            loadChildren:
              './pages/administrator-page/self-study/modifica-documento/modifica-documento.module#ModificaDocumentoModule',
            canActivate: [AuthGuard, RoleTutorOrAdministratorGuard],
          },
        ],
      },
      {
        path: 'a-profilo',
        data: {
          title: 'Profilo',
        },
        children: [
          {
            path: 'modifica',
            loadChildren:
              './pages/administrator-page/profilo/modifica/modifica-profilo.module#ModificaProfiloModule',
            canActivate: [AuthGuard, RoleAdministratorOrTutorOrInstractorGuard],
          },
        ],
      },
      {
        path: 'a-agenda',
        data: {
          title: 'Agenda',
        },
        children: [
          {
            path: 'verificare',
            loadChildren:
              './pages/administrator-page/agende/verificare/verificare-agende.module#VerificareAgendeModule',
            canActivate: [AuthGuard, RoleTutorOrAdministratorGuard],
          },
        ],
      },
      {
        path: 'a-studente',
        data: {
          title: 'Studente',
        },
        children: [
          {
            path: 'list',
            loadChildren:
              './pages/administrator-page/studente/list/list-studenti.module#ListStudentiModule',
            canActivate: [AuthGuard, RoleAdministratorOrTutorOrInstractorGuard],
          },
          {
            path: 'modifica',
            loadChildren:
              './pages/administrator-page/studente/modifica/modifica-studente.module#ModificaStudenteModule',
            canActivate: [AuthGuard, RoleAdministratorOrTutorOrInstractorGuard],
          },
          {
            path: 'crea',
            loadChildren:
              './pages/administrator-page/studente/crea/crea-studente.module#CreaStudenteModule',
            canActivate: [AuthGuard, RoleAdministratorGuard],
          },
          {
            path: 'dettaglio',
            loadChildren:
              './pages/administrator-page/studente/dettaglio/dettaglio-studente.module#DettaglioStudenteModule',
            canActivate: [AuthGuard, RoleAdministratorOrTutorOrInstractorGuard],
          },
        ],
      },
      {
        path: 'a-laboratorio-lezione-tutoraggio',
        data: {
          title: 'Laboratorio',
        },
        children: [
          {
            path: 'list',
            // tslint:disable-next-line: max-line-length
            loadChildren:
              './pages/administrator-page/laboratorio-lezione-tutoraggio/list/list-laboratori-lezione-tutoraggio.module#ListLaboratorioLezioneTutoraggioModule',
            canActivate: [AuthGuard, RoleTutorOrAdministratorGuard],
          },
          {
            path: 'calendario',
            // tslint:disable-next-line: max-line-length
            loadChildren:
              './pages/administrator-page/laboratorio-lezione-tutoraggio/calendario/calendario-laboratorio.module#CalendarioLaboratorioModule',
            canActivate: [AuthGuard, RoleTutorOrAdministratorGuard],
          },
          {
            path: 'appelli',
            // tslint:disable-next-line: max-line-length
            loadChildren:
              './pages/administrator-page/laboratorio-lezione-tutoraggio/appelli/appelli-laboratori-lezione-tutoraggio.module#AppelliLaboratorioLezioneTutoraggioModule',
            canActivate: [AuthGuard, RoleTutorOrAdministratorGuard],
          },
          {
            path: 'dettaglio',
            // tslint:disable-next-line: max-line-length
            loadChildren:
              './pages/administrator-page/laboratorio-lezione-tutoraggio/dettaglio/dettaglio-laboratorio-lezione-tutoraggio.module#DettaglioLaboratorioLezioneTutoraggioModule',
            canActivate: [AuthGuard, RoleTutorOrAdministratorGuard],
          },
          {
            path: 'crea',
            // tslint:disable-next-line: max-line-length
            loadChildren:
              './pages/administrator-page/laboratorio-lezione-tutoraggio/crea/crea-laboratorio-lezione-tutoraggio.module#CreaLaboratorioLezioneTutoraggioModule',
            canActivate: [AuthGuard, RoleTutorOrAdministratorGuard],
          },
          {
            path: 'modifica',
            // tslint:disable-next-line: max-line-length
            loadChildren:
              './pages/administrator-page/laboratorio-lezione-tutoraggio/modifica/modifica-laboratorio-lezione-tutoraggio.module#ModificaLaboratorioLezioneTutoraggioModule',
            canActivate: [AuthGuard, RoleTutorOrAdministratorGuard],
          },
        ],
      },
      {
        path: 'a-funzionalita',
        data: {
          title: 'Laboratorio',
        },
        children: [
          {
            path: 'genera-gruppi-studio',
            // tslint:disable-next-line: max-line-length
            loadChildren:
              './pages/administrator-page/funzionalita/genera-gruppi-studio/genera-gruppi-studio.module#GeneraGruppiStudioModule',
            canActivate: [AuthGuard, RoleAdministratorGuard],
          },
          {
            path: 'carica-voti-placement',
            // tslint:disable-next-line: max-line-length
            loadChildren:
              './pages/administrator-page/funzionalita/carica-voti-placement/carica-voti-placement.module#CaricaVotiPlacementModule',
            canActivate: [AuthGuard, RoleAdministratorGuard],
          },
          {
            path: 'carica-voti-finali',
            // tslint:disable-next-line: max-line-length
            loadChildren:
              './pages/administrator-page/funzionalita/carica-voti-prova-finale/carica-voti-prova-finale.module#CaricaVotiProvaFinaleModule',
            canActivate: [AuthGuard, RoleAdministratorGuard],
          },
          {
            path: 'download-studenti-placement',
            // tslint:disable-next-line: max-line-length
            loadChildren:
              './pages/administrator-page/funzionalita/download-studenti-placement/download-studenti-placement.module#DownloadStudentiPlacementModule',
            canActivate: [AuthGuard, RoleAdministratorGuard],
          },
          {
            path: 'registrazione-sistema',
            // tslint:disable-next-line: max-line-length
            loadChildren:
              './pages/administrator-page/funzionalita/registrazione-sistema/registrazione-sistema.module#RegistrazioneSistemaModule',
            canActivate: [AuthGuard, RoleAdministratorGuard],
          },
        ],
      },
    ],
  },
  {
    path: 'login',
    loadChildren: './+login/login.module#LoginModule',
    data: {
      customLayout: true,
    },
  },
  {
    path: 'register',
    loadChildren: './+register/register.module#RegisterModule',
    data: {
      customLayout: true,
    },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
